/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './file-upload.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../file-input/file-input.component.ngfactory';
import * as i3 from '@angular/forms';
import * as i4 from '@covalent/core/file/file-input/file-input.component';
import * as i5 from '@angular/common';
import * as i6 from '@angular/material';
import * as i7 from '../../../../@angular/material/typings/index.ngfactory';
import * as i8 from '@covalent/core/file/file-upload/file-upload.component';
const styles_TdFileUploadComponent:any[] = [i0.styles];
export const RenderType_TdFileUploadComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdFileUploadComponent,data:{}});
function View_TdFileUploadComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_TdFileUploadComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'td-file-input',
      ([] as any[]),(null as any),[[(null as any),'select']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('select' === en)) {
          const pd_0:any = ((<any>_co.handleSelect($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_TdFileInputComponent_0,i2.RenderType_TdFileInputComponent)),i1.ɵprd(5120,
      (null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.TdFileInputComponent]),i1.ɵdid(49152,(null as any),0,i4.TdFileInputComponent,
      [i1.Renderer2,i1.ChangeDetectorRef],{color:[0,'color'],multiple:[1,'multiple'],
          accept:[2,'accept'],disabled:[3,'disabled']},{onSelect:'select'}),(_l()(),
      i1.ɵted(0,['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),0,2,(null as any),
      View_TdFileUploadComponent_2)),i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),i1.ɵdid(147456,(null as any),
      0,i6.PortalHostDirective,[i1.ComponentFactoryResolver,i1.ViewContainerRef],{portal:[0,
          'portal']},(null as any)),(_l()(),i1.ɵted(0,['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.defaultColor;
    const currVal_1:any = _co.multiple;
    const currVal_2:any = _co.accept;
    const currVal_3:any = _co.disabled;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = true;
    _ck(_v,5,0,currVal_4);
    const currVal_5:any = _co.inputLabel;
    _ck(_v,6,0,currVal_5);
  },(null as any));
}
function View_TdFileUploadComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'div',[['layout',
      'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          6,'button',[['class','td-file-upload mat-raised-button'],['md-raised-button',
              ''],['type','button']],[[8,'disabled',0]],[[(null as any),'keyup.delete'],
              [(null as any),'keyup.backspace'],[(null as any),'keyup.escape'],[(null as any),
                  'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keyup.delete' === en)) {
              const pd_0:any = ((<any>_co.cancel()) !== false);
              ad = (pd_0 && ad);
            }
            if (('keyup.backspace' === en)) {
              const pd_1:any = ((<any>_co.cancel()) !== false);
              ad = (pd_1 && ad);
            }
            if (('keyup.escape' === en)) {
              const pd_2:any = ((<any>_co.cancel()) !== false);
              ad = (pd_2 && ad);
            }
            if (('click' === en)) {
              const pd_3:any = ((<any>_co.uploadPressed()) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },i7.View_MdButton_0,i7.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i6.MdPrefixRejector,[[2,i6.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,[['fileUpload',4]],0,i6.MdButton,
          [i1.ElementRef,i1.Renderer2,i6.Platform,i6.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i6.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,[' \n    '])),
      i1.ɵncd(0,0),(_l()(),i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),9,'button',[['class','td-file-upload-cancel mat-icon-button'],
          ['md-icon-button',''],['type','button']],[[8,'disabled',0]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.cancel()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i7.View_MdButton_0,i7.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
          i6.MdPrefixRejector,[[2,i6.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(180224,(null as any),0,i6.MdButton,[i1.ElementRef,
          i1.Renderer2,i6.Platform,i6.FocusOriginMonitor],{color:[0,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i6.MdIconButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'md-icon',[['role','img']],[[2,'mat-icon',(null as any)]],(null as any),
          (null as any),i7.View_MdIcon_0,i7.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),
          0,i6.MdPrefixRejector,[[2,i6.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(9027584,(null as any),0,i6.MdIcon,[i1.ElementRef,
          i1.Renderer2,i6.MdIconRegistry],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['cancel'])),(_l()(),i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.activeColor;
    _ck(_v,4,0,currVal_1);
    const currVal_3:any = _co.cancelColor;
    _ck(_v,12,0,currVal_3);
    _ck(_v,17,0);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,4).disabled || (null as any));
    _ck(_v,2,0,currVal_0);
    const currVal_2:any = (i1.ɵnov(_v,12).disabled || (null as any));
    _ck(_v,10,0,currVal_2);
    const currVal_4:any = true;
    _ck(_v,15,0,currVal_4);
  });
}
export function View_TdFileUploadComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TdFileUploadComponent_1)),i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TdFileUploadComponent_3)),i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i8.TdFileUploadComponent = _v.component;
    const currVal_0:boolean = !_co.files;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.files;
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_TdFileUploadComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-file-upload',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdFileUploadComponent_0,
      RenderType_TdFileUploadComponent)),i1.ɵdid(49152,(null as any),1,i8.TdFileUploadComponent,
      [i1.ChangeDetectorRef],(null as any),(null as any)),i1.ɵqud(335544320,1,{inputLabel:0})],
      (null as any),(null as any));
}
export const TdFileUploadComponentNgFactory:i1.ComponentFactory<i8.TdFileUploadComponent> = i1.ɵccf('td-file-upload',
    i8.TdFileUploadComponent,View_TdFileUploadComponent_Host_0,{defaultColor:'defaultColor',
        activeColor:'activeColor',cancelColor:'cancelColor',multiple:'multiple',accept:'accept',
        disabled:'disabled'},{onSelect:'select',onUpload:'upload',onCancel:'cancel'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/file/file-upload/file-upload.component.ngfactory.ts